import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { Box, Card, ListItem, ListItemIcon, Menu, MenuItem, Stack, useTheme } from "@mui/material";
import { format } from "date-fns";
import { strings } from "../../../localization/LocalizedStrings";
import { CustomLoadingIndicator } from "../../CustomLoadingIndicator";
import { useContextMenu } from "../../../hooks/contextMenu";
import { Icon, IconType } from "../../../icons";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { useUser } from "../../../hooks/session";

export const PasskeyItem: FunctionComponent<IPasskeyItemProps> = ({
  id,
  createdUnixTimestamp,
  onDelete
}) => {
  const theme = useTheme();
  const [isLoading] = useState(false);
  const { menuProps, handleContextMenu, handleMenuClose } = useContextMenu();
  const [user] = useUser.useState();
  return (
    <ListItem className={styles.item}>
      <Card className={styles.container} elevation={5}>
        <Stack
          className={styles.actionArea}
          onContextMenu={handleContextMenu}
          direction={"row"}
          sx={{ width: "100%" }}
        >
          <Stack sx={{ width: "100%", alignItems: "center" }} direction={"row"} spacing={2}>
            {isLoading ? <CustomLoadingIndicator /> : <Icon type={IconType.Passkey} />}
            <Stack sx={{ width: "100%" }} spacing={1}>
              <Stack direction={"row"} alignItems={"center"}>
                <Stack>
                  <p className={styles.name} style={{ color: theme.palette.primary.main }}>
                    {strings.passkey_title}
                  </p>
                  <p className={styles.description}>{user.email}</p>
                </Stack>
                <Box flexGrow={1} />
                <p className={styles.visibility}>
                  {format(+createdUnixTimestamp * 1000, "d MMMM yyyy HH:mm", {
                    locale: strings.fnsLocale
                  })}
                </p>
                <ToolbarButton
                  onClick={() => onDelete(id)}
                  tooltip={strings.delete}
                  iconType={IconType.DeleteForever}
                  color={theme.palette.colors?.remove}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Card>
      <Menu {...menuProps}>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            onDelete(id);
          }}
          style={{ color: theme.palette.colors?.remove }}
          dense
        >
          <ListItemIcon>
            <Icon style={{ color: theme.palette.colors?.remove }} type={IconType.DeleteForever} />
          </ListItemIcon>
          {strings.delete}
        </MenuItem>
      </Menu>
    </ListItem>
  );
};

export interface IPasskeyItemProps {
  id: string;
  createdUnixTimestamp: string;
  onDelete: (id: string) => void;
}
